var tocSingleJS = (function () {

  var tocSect, sidebarLinks, sidebarLinksParent, content, sideDivWrapper, sideBarInner;
  
  function init() {
    sidebarLinksParent = document.querySelectorAll('.single-tmp__toc-list ul li');
    content = document.querySelector('.single-tmp__main');
    sidebarLinks = document.querySelectorAll('.single-tmp__toc-list ul li a');
    tocSect = document.querySelector('.single-tmp__sidebar .single-tmp__toc-container');
    sideDivWrapper = document.querySelector('.single-tmp__articles-box');

    uiBindings();
  }

  function uiBindings() {
    // Add id on heading elements
    tocHeadingElem();

    function handleScrollAndResizeEvents() {
      stickyTocOnScroll();
      highlightToc();
    }

    window.addEventListener('scroll', handleScrollAndResizeEvents);
    window.addEventListener('resize', handleScrollAndResizeEvents);

    // Sidebar link click event
    if (sidebarLinks){
      for (var i = 0; i < sidebarLinks.length; i++) {
        sidebarLinks[i].addEventListener('click', setActiveToc);
      }
    }

    var tocBtn = document.querySelector('.single-tmp__content .single-tmp__toc-heading-mob');
    if (tocBtn) {
      tocBtn.addEventListener("click", function () {
        var that = this;
        if (that.parentElement.classList.contains("active")) {
          that.parentElement.classList.remove("active");
          that.setAttribute('aria-expanded', 'false');
        } else {
          that.parentElement.classList.add("active");
          that.setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  function stickyTocOnScroll() {
    if (window.innerWidth >= 1280 && tocSect) {
      var relatedPosts = document.querySelector('.single-r-a'),
        sidebar = document.querySelector('.single-tmp__sidebar'),
        sidebarBottom = sidebar.getBoundingClientRect().bottom,
        windowYOffset = window.pageYOffset;

      if (windowYOffset <= content.offsetTop) {
        if (tocSect.classList.contains('toc-sticky') || tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.remove('toc-sticky', 'toc-bottom');
        }
      } else if ((sidebarBottom - 131) <= 0) {
        if (tocSect.classList.contains('toc-sticky') || tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.remove('toc-sticky', 'toc-bottom');
        }
      } else if ((windowYOffset > content.offsetTop) && ((windowYOffset + tocSect.offsetHeight + (sideDivWrapper ? sideDivWrapper.offsetHeight : 0)) < (relatedPosts.offsetTop - 168))) {
        if (!tocSect.classList.contains('toc-sticky')) {
          tocSect.classList.add('toc-sticky');
        }
        if (tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.remove('toc-bottom');
        }
      } else {
        if (tocSect.classList.contains('toc-sticky')) {
          tocSect.classList.remove('toc-sticky');
        }
        if (!tocSect.classList.contains('toc-bottom')) {
          tocSect.classList.add('toc-bottom');
        }
      }
    } else {
      tocSect.classList.remove('toc-sticky', 'toc-bottom');
    }
  }

  
  function highlightToc() {
    if (window.innerWidth >= 1280 && tocSect && tocSect.classList.contains('toc-sticky')) {
      var activeToc = document.querySelector(".single-tmp__toc-list ul li a.active"),
        activeIndex = 0;
      
      for (var s = 0; s < sidebarLinks.length; s++) {
        var tocHeadingID = sidebarLinks[s].getAttribute("data-scrollto"),
        tocHeadingDom = document.querySelector(tocHeadingID);

        if (tocHeadingDom) {
          var tocHeadingDomRect = tocHeadingDom.getBoundingClientRect();
          if ((tocHeadingDomRect.top - 90) < 0) {
            activeIndex = s;
          }
        }
      }

      if (activeToc && activeToc.classList.contains('active')) {
        activeToc.classList.remove("active");
        var parentLi = sidebarLinks[activeIndex].parentElement;
        // If the clicked link is not inside a nested list
        if (parentLi.parentElement.tagName === 'UL' && parentLi.parentElement.parentElement.tagName !== 'LI') {
          parentLi.classList.remove('active');
        }
        // If the clicked link is inside a nested list, add 'active' to its grandparent list item
        if (parentLi.parentElement.parentElement && parentLi.parentElement.parentElement.tagName === 'LI') {
          parentLi.parentElement.parentElement.classList.remove('active');
        }
      }
      
      // Scroll the active link into view within the TOC
      if (sidebarLinks[activeIndex]) {
        sidebarLinks[activeIndex].scrollIntoView({ behavior: "smooth", block: "center" });
      }

      setActiveTocParent(sidebarLinks[activeIndex]);
    }
  }

  function setActiveToc(event) {
    var that = event.target;
    setActiveTocParent(that);
  }

  function setActiveTocParent(activeToc) {
    // Remove active class from all parent list items
    for (var a = 0; a < sidebarLinksParent.length; a++) {
      sidebarLinksParent[a].classList.remove('active');
    }

    // Remove active class from all links
    for (var b = 0; b < sidebarLinks.length; b++) {
      sidebarLinks[b].classList.remove('active');
    }

    // If the clicked link is not inside a nested list
    if (activeToc) {
      activeToc.classList.add('active');
    }
  }

  var tocHeadingElem = function () {
    var parentHeading = document.querySelector('.single-tmp__content'),
      parentBlock = document.querySelector('.single-tmp__toc-list'),
      tocBlock = document.querySelector('.single-tmp__toc'),
      allHeading = parentHeading.querySelectorAll('h2:not(.hide-toc-heading), h3:not(.hide-toc-heading), h4:not(.hide-toc-heading)');
      
    if (!tocBlock) {
      return false;
    }

    // retrun if heading list is less than 3 or greater than 20
    if (allHeading.length < 3 || allHeading.length > 30) {
      tocBlock.remove();
      return false;
    }

    for (var i = 0; i < allHeading.length; i++) {
      var clearInnerHeading = allHeading[i].innerHTML.replace(/\n|<.*?>/g,'');
      if (allHeading[i].nodeName == 'H2' || allHeading[i].nodeName == 'H3') {
        if(clearInnerHeading) {
          if (i == 0) {
            allHeading[i].setAttribute("id", "toc0");
          } else {
            allHeading[i].setAttribute("id", "toc" + i);
          }
        }
      }

      if (allHeading[i].nodeName == 'H4') {
        if(clearInnerHeading) {
          allHeading[i].setAttribute("id", "toc" + i);
        }
      }
    }

    // Remove unwanted anchor tag
    var anchors = parentBlock.getElementsByTagName("a");
    for(var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i];
      if(anchor.innerHTML == "") {
        anchor.parentNode.removeChild(anchor); //removes the anchor
      }
    }
  };

  init();
})();
